export default function ({ store, redirect, route }) {
  if (store.getters['client/isClientExternal']) {
    if (route.path === '/contacts/' + route.params.id + '/tasks') {
      return redirect('/contacts/' + route.params.id);
    }
    return redirect('/contacts/' + route.params.id);
  }
}
